$(function() { 
    // step 2 overlay html insert
    $("#main_frame").prepend('<div id="custom_step2_overlay" style="display:none;"><div id="custom_step2_overlay_inside"></div></div>');
    
    $("#custom_step2_overlay_inside").html($("#custom_step2_content").html());
    
    $("#custom_picker .a_button").click(
        function() {
            
            // add "active" class for mouseover effects
            $("#custom_picker .a_button").removeClass('active');
            $(this).addClass('active');
            
            // fade out temporarily for click effect
            $("#custom_picker .a_button img").stop(true, true).fadeOut(200);
            
            // fade in the colored image
            $('img', this).stop(true, true).fadeIn(300);
            
            // slide up all other contents
            $("#custom_picker .a_content").not($(this).next()).slideUp("fast");
            
            // slide down next
            if ($(this).next().is(':hidden')) {
                $(this).next().slideDown();
            }
            
            // fade in overlay if step 2
            if ($(this).hasClass('step2') == true) {
                $("#custom_step2_overlay").fadeIn(400);
                // reset disclaimer
                $("#disclaimer_text").hide();
            } else {
                $("#custom_step2_overlay").fadeOut(200);
            }
            
            if ($(this).hasClass('step3') == true) { 
                price = $("#price").html();
                $("#price2").html(price);
                if ($("#proof_checkbox").is(':checked') == true) {
                    $("#proof").html("+$10.00 Proof");
                } else {
                    $("#proof").html("");
                }
            }
        })// end click
    $("#custom_picker .a_button").hover(
        function() {
            if ($('img', this).is(':hidden')) {
                $('img', this).stop(true, true).fadeIn(50);
            }
        },
        function() { 
            if ($(this).hasClass('active') != true) {
                $('img', this).stop(true, true).fadeOut(100);
        }})// end hover
    $("#custom_picker .download_links div.icon").hover(
        function() {$(this).css( {'background-image': 'url(//cdn.shopify.com/s/files/1/0060/1852/assets/custom_dl_selected.png?v=1289953447)'})},
        function() {$(this).css( {'background-image': 'none' })} 
    )// end hover
    
    
    
    // PROOF HANDLING
    $("input[name=proof]").change( 
        function() { 
            if ($(this).attr('checked') == true) {
                //checked. add proof to cart. add id[] for multiple
                $("#id").append('</input><input type="hidden" name="id[]" value="41494592">');
            } else {
                // not checked.
                $("#id").html('');
            }; 
    });


Shopify.onCartUpdate = function(cart) {};
$("#add_to_cart").click(function() {
    // for people with JS enabled, add the item in via ajax and add cart attribute
    var varID = $("#id").val();
    var upload_num = location.hash.substr(1);
    var upload;
    if ($("#proof_checkbox").is(':checked')) { Shopify.addItem('41494592', 1, add_item) } else { add_item();};
    function add_item() {Shopify.addItem(varID, 1, Shopify.getCart(update_atts))}
    function update_atts(cart) {
        attributes = cart.attributes;
        if (attributes != undefined) {
            upload = cart.attributes['upload_number'];
        }
            
        if (upload != undefined) {
            if (upload.charAt(upload.length-1) != ',') {
                upload = upload + ',';
            }
            
            if (upload.indexOf(upload_num) == -1) { // if upload num not already in str.
                combined = upload + upload_num;
                Shopify.updateCartAttributes({'upload_number': combined}, redirect);
            } else {
                redirect() // don't add more, just redirect.
            }
        } else {
            Shopify.updateCartAttributes({'upload_number': upload_num}, redirect);
        }
    }
    function redirect(cart){ 
        window.location = 'http://www.grovemade.com/cart/';
    }// end redirect
});
Shopify.onItemAdded = function() { };
    
    
    


})